import { useCollectionShelfPublications } from './useCollectionShelfPublications';

/** How many publications a collection currently resolves to. The admin has
 * no count field — the number rides on `x-total-count` of the shelf preview
 * query, deliberately the same query, so a home page showing both the
 * preview and the lineup rows pays one request per collection, not two. */
export const useCollectionPublicationCount = (
  collectionId: number,
  enabled = true
) => {
  const { total, isLoading } = useCollectionShelfPublications(
    collectionId,
    enabled
  );

  return { count: total, isLoading };
};
